import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { saveCredsInLocalStorage, claimPendingAttribution } from "../services/AuthService";
import { getUser } from "../services/UserService";
import { consumePendingAuthIntent, getAuthReturnRetailer } from "../utils/authReturn";
import { defaultPostAuthPath, heldPostAuthPath } from "../utils/dealOnboarding";
import { track } from "../utils/analytics";
import { clearSignupReferrer } from "../services/AttributionService";

export default function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const complete = async () => {
      const accessToken = searchParams.get("access_token");
      const refreshToken = searchParams.get("refresh_token");
      const error = searchParams.get("error");

      if (error) {
        console.error("Google OAuth error:", error);
        window.location.href = `/login?error=${encodeURIComponent(error)}`;
        return;
      }

      if (accessToken && refreshToken) {
        saveCredsInLocalStorage(accessToken, refreshToken);
        const newSignup = searchParams.get("new_signup") === "1";
        await claimPendingAttribution(newSignup, 1500, newSignup);
        if (!newSignup) clearSignupReferrer();
        const user = await getUser();
        if (newSignup) {
          track("signup", { method: "google", source: "oauth" });
        }
        const held = heldPostAuthPath(user);
        if (held) {
          window.location.href = held;
          return;
        }
        const intent = consumePendingAuthIntent(defaultPostAuthPath(user));
        const destination = intent.returnTo;
        if (destination !== "/") {
          track("guest_intent_resumed", { surface: "web", retailer: getAuthReturnRetailer(destination), trigger: "oauth_callback", source: intent.source || "google" });
        }
        window.location.href = destination;
        return;
      }

      window.location.href = "/login?error=missing_tokens";
    };

    void complete();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 dark:from-dark-900 dark:via-dark-950 dark:to-dark-900 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-400 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-dark-300">Completing Google login...</p>
      </div>
    </div>
  );
}
